import React, { useState } from "react";
import {
  Divider,
  Button,
  Grid,
  Box,
  Typography,
  MenuItem,
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  styled,
  Link,
  FormHelperText,
  TextField,
} from "@mui/material";
import FileUpload from "@mui/icons-material/FileUpload";
import ClearIcon from "@mui/icons-material/Clear";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_NEW_QUERY } from "../../utils/Validation";
import { addNewQueryService } from "../../services/queryServices";
import { useNotificationContext } from "../../common/NotificationContext";
import { useLoading } from "../../common/LoadingContext";
import useGlobalState from "../../Context";

import download from "downloadjs";

const Input = styled("input")({
  display: "none",
});
export default function AddQueryModal({ queryTypeList, onSaveAction }) {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [{ userDetails }] = useGlobalState();
  const userParam = userDetails?.userParam;
  const formOption = {
    resolver: yupResolver(ADD_NEW_QUERY),
    defaultValues: { queryType: "" },
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    watch,
    reset,
  } = useForm(formOption);

  const [imageUpload, setImageUpload] = useState([]);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    clearErrors();
  };

  const handleClose = () => {
    reset();
    setImageUpload([]);
    setOpen(false);
  };

  const onImageChange = (event) => {
    if (
      event.target.files === null ||
      event.target.files === undefined ||
      event.target.files.length === 0
    ) {
      setImageUpload(null);
    } else {
      let pattern = /image-*/;
      if (!event?.target?.files[0]?.type?.match(pattern)) {
        showNotification("Error", "Invalid type selected, Please try again.");
        setImageUpload(null);
      } else {
        if (event.target.files[0].size >= 10485760) {
          showNotification(
            "Error",
            "File too Big, please select a file less than 10mb"
          );
          setImageUpload(null);
        } else {
          setImageUpload(event.target.files);
        }
      }
    }
  };
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const requestBody = {
        subTypeCode: data.querySubType,
        comment: data.comment,
        typeCode: data.queryType,

        userName: userParam?.userId,
        is_attachment: imageUpload?.length > 0 ? true : false,
        file: imageUpload?.[0],
      };

      const addQueryResponse = await addNewQueryService(baseUrl, requestBody);
      if (addQueryResponse?.messageCode === 6) {
        showNotification(
          "Success",
          `Query ${addQueryResponse?.queryDetailParam?.queryId} Raised Successfully`,
          "success"
        );
        handleClose();
        onSaveAction();
        reset();
        setImageUpload([]);
      } else {
        showNotification(
          "Error",
          addQueryResponse?.message ?? "Failed to Raise Query"
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed to Raise Query");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        sx={{ ml: 1, fontSize: "13px", background: "#4d6fa5", color: "#fff" }}
        onClick={handleClickOpen}
      >
        Add Query
      </Button>
      {open && (
        <Dialog
          fullWidth
          maxWidth="sm"
          open={open}
          onClose={handleClose}
          disableEscapeKeyDown={true}
        >
          <DialogTitle>
            <Typography variant="h6" color="primary">
              Add Query
            </Typography>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Grid>
              <Grid item xs={12} md={12}>
                <Grid item xs={12} md={12}>
                  <Box sx={{ mt: 3 }}>
                    {open && (
                      <form>
                        <Grid
                          container
                          spacing={1}
                          direction="row"
                          justifyContent="left"
                          alignItems="center"
                        >
                          <Grid item xs={12} sm={4}>
                            <FormLabel
                              required={true}
                              sx={{
                                float: "left",
                                color: "#767676",
                                fontSize: 13,
                              }}
                            >
                              Query Type
                            </FormLabel>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Select
                              sx={{ width: "100%" }}
                              size="small"
                              {...register("queryType", { required: true })}
                              error={Boolean(errors?.queryType)}
                              helperText={errors?.queryType?.message}
                            >
                              {queryTypeList !== null &&
                                queryTypeList.map((name) => (
                                  <MenuItem
                                    native
                                    key={name.typeId}
                                    sx={{ width: "100%" }}
                                    value={name.typeCode}
                                    size="small"
                                  >
                                    {name.type}
                                  </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText error>
                              {errors?.queryType?.message}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <FormLabel
                              required={true}
                              sx={{
                                float: "left",
                                color: "#767676",
                                fontSize: 13,
                              }}
                            >
                              Query Sub Type
                            </FormLabel>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Select
                              sx={{ width: "100%" }}
                              name="querySubType"
                              {...register("querySubType", { required: true })}
                              size="small"
                              error={Boolean(errors?.querySubType)}
                              helperText={errors?.querySubType?.message}
                              disabled={watch("queryType") === ""}
                            >
                              {watch("queryType") !== "" &&
                                queryTypeList !== null &&
                                queryTypeList
                                  .filter(
                                    (temp) =>
                                      temp.typeCode === watch("queryType")
                                  )[0]
                                  .querySubTypeParam.map((item1) => (
                                    <MenuItem
                                      native
                                      key={item1.subTypeId}
                                      sx={{ width: "100%" }}
                                      value={item1.subTypeCode}
                                      //   style={getStyles(name, personName, theme)}
                                    >
                                      {item1.subType}
                                    </MenuItem>
                                  ))}
                            </Select>
                            <FormHelperText error>
                              {errors?.querySubType?.message}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <FormLabel
                              required={true}
                              sx={{
                                float: "left",
                                color: "#767676",
                                fontSize: 13,
                              }}
                            >
                              Comment
                            </FormLabel>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <TextField
                              style={{
                                border: Boolean(errors?.comment)
                                  ? "1px solid red"
                                  : "",
                                width: "100%",
                              }}
                              sx={{ color: "#767676", width: "100%" }}
                              name="comment"
                              required
                              multiline
                              rows={4}
                              size="small"
                              autoComplete="off"
                              {...register("comment", { required: true })}
                              error={Boolean(errors?.comment)}
                              helperText={errors?.comment?.message}
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <FormLabel
                              sx={{
                                float: "left",
                                color: "#4d6fa5",
                                fontSize: 13,
                              }}
                            >
                              File
                            </FormLabel>
                          </Grid>
                          <Grid item xs={12} sm={8} mt={1}>
                            <label htmlFor="contained-button-file">
                              <Input
                                accept="image/png, image/jpg, image/jpeg"
                                id="contained-button-file"
                                type="file"
                                onChange={onImageChange}
                                disabled={
                                  imageUpload?.length > 0 ? true : false
                                }
                              />
                              <Button
                                variant="contained"
                                startIcon={<FileUpload />}
                                component="span"
                                sx={{ color: "#fff", fontSize: "13px" }}
                                disabled={
                                  imageUpload?.length > 0 ? true : false
                                }
                              >
                                Upload
                              </Button>
                            </label>
                            <Box>
                              <Typography
                                variant="caption"
                                color={"primary"}
                                fontStyle={"italic"}
                              >
                                * You can only upload <b>jpg, png, jpeg</b>{" "}
                                files. <br></br>* Maximum upload file size -{" "}
                                <b>10 mbs.</b>
                              </Typography>
                            </Box>
                            {imageUpload &&
                              Array.from(imageUpload)?.map((imageElement) => {
                                return (
                                  <Grid item>
                                    <Box mx={0.5} display={"flex"}>
                                      <Link
                                        onClick={() => {
                                          download(
                                            imageElement,
                                            imageElement.name
                                          );
                                        }}
                                        variant="body2"
                                      >
                                        {imageElement.name}
                                      </Link>
                                      <ClearIcon
                                        fontSize="small"
                                        color="error"
                                        onClick={() => {
                                          setImageUpload(
                                            Array.from(imageUpload).filter(
                                              (image) => {
                                                return (
                                                  image.name !==
                                                  imageElement.name
                                                );
                                              }
                                            )
                                          );
                                        }}
                                      />
                                    </Box>
                                  </Grid>
                                );
                              })}
                          </Grid>
                        </Grid>
                      </form>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button
              variant="outlined"
              sx={{ fontSize: "13px" }}
              onClick={handleClose}
              color="error"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ fontSize: "13px", background: "#4d6fa5", color: "#fff" }}
              onClick={handleSubmit(onSubmit)}
              autoFocus
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
